import { convertCellTopList } from '@/common/converter/convert-cell-top-list'
import { getConvertCell } from '@/common/converter/utils/get-convert-cell'

/**
 * source (from HomeData) 와 target (from Catalog) 를 받아 list 데이터로 변환
 * @param note ?
 * @param type ?
 * @param subType ?
 * @param version ?
 * @param filter ?
 * @param uiType
 * @param source
 * @param target
 * @returns {{note: *, type: *, sub_type: *, version: *, gen_time: string, cell_toplist: {blurtarget_img: string, cta: string, bgcolor: string, pagecount: string, count: string, title_list: *[]}, filter: {}, tvcut_bybroadcaster_list: {}}}
 */
export const convertListSource = ({
  note = '',
  type = '',
  subType = '',
  version = '',
  uiType = '',
  filter = {},
  source = [],
  target = {},
}) => {
  const convertCell = getConvertCell(uiType)
  return {
    note,
    type,
    sub_type: subType,
    version,
    gen_time: '',
    cell_toplist: {
      ...convertCellTopList(source, target?.topContext),
      cell_type: uiType,
      celllist: target.contextList.map((target) => convertCell(source, target)),
    },
    filter,
    tvcut_bybroadcaster_list: {},
  }
}
